import React, { useEffect, useState, useRef } from "react";
import DynamicTable from "../DynamicTable";


const SectionTwo = (props) => {
    const {handleButtonClick ,setSelectedOptions ,selectedOptions,toggleOption ,setMessageBoard,setErrorTabEnable ,data ,showMaximumChat} = props

    const [onClickYes, setOnClickYes] = useState(false);
    const [onClickNo, setOnClickNo] = useState(false);

    

    const isYesStepValid = (data?.step_2_yes_next_steps || data?.step_2_active_next_steps  || '' ).toLowerCase() !== 'no';
    const isNoStepValid = (data?.step_2_no_next_steps || data?.step_2_deactive_next_steps  || '' ).toLowerCase() !== 'no';

  //   useEffect(()=>{
  //     if (onClickNo && data?.step_2_no_text?.toLowerCase() === "nan") {
  //         props?.addMessages("Work Order", 10);
  //     }
  // }, [onClickNo, onClickYes])

  //   useEffect(()=>{
     
  //     if(onClickYes && data?.step_2_yes_call_logs){
  //         localStorage.setItem(
  //             "troubleShooting",
  //             JSON.stringify({ key1: data?.step_2_yes_call_logs })
  //           );
  //     }
  //     if(isNoStepValid && data?.step_2_no_call_logs ){
  //         localStorage.setItem(
  //             "troubleShooting",
  //             JSON.stringify({ key1: data?.step_2_no_call_logs })
  //           );
  //     }
  // })

  return (
    <div>
    <div className="error-message-head1" style={{fontSize : showMaximumChat && '16px'}} >{data?.step_2_title}</div>
    <div className="error-message-head2" style={{fontSize : showMaximumChat && '16px'}} dangerouslySetInnerHTML={{ __html: data?.step_2_desc}}>
    </div>
    <div style={{ gap: "8px", display: "flex", marginTop: "22px" }}>
      <button
        onClick={() => {
          localStorage.setItem(
            "troubleShooting",
            JSON.stringify({ key1: data?.step_2_yes_call_logs })
          );
          handleButtonClick(2, "active" ,{section : 'two',value:isYesStepValid});
          setOnClickYes(true);
          setOnClickNo(false);
          if (isYesStepValid) {
            setSelectedOptions([true, true, true, false, false, false, false]);
         } else{
          setSelectedOptions([true, true, false, false, false, false, false]);
         }
        
        }}
        
       
        className={`option-button ${
          toggleOption[2] === "active" ? "clicked" : ""
        }`}
      >
       {data?.step_2_active_text ? 'Active' : "Yes"} 
      </button>
      <button
        onClick={() => {
          localStorage.setItem(
            "troubleShooting",
            JSON.stringify({ key1: data?.step_2_no_call_logs })
          );
          handleButtonClick(2, "deactive" ,{section : 'two',value:isYesStepValid});
          setOnClickYes(false);
          setOnClickNo(true);
          if (isNoStepValid) {
            setSelectedOptions([true, true, true, false, false, false, false]);
        } else{
          setSelectedOptions([true, true, false, false, false, false, false]);
        }
        }}
        className={`option-button ${
          toggleOption[2] === "deactive" ? "clicked" : ""
        }`}
       
      >
        {data?.step_2_deactive_text  ? "Deactive" : "No" }
      </button>
    </div>
    
    {onClickYes && <div className="error-message-head2" style={{fontSize : showMaximumChat && '16px'}} dangerouslySetInnerHTML={{ __html: data?.step_2_yes_text || data?.step_2_active_text  }}></div>}
    {onClickNo && data?.step_2_no_text?.toLowerCase() !== "nan" && <div className="error-message-head2" style={{fontSize : showMaximumChat && '16px'}} dangerouslySetInnerHTML={{ __html: data?.step_2_no_text || data?.step_2_deactive_text  }}></div>}
    
    {onClickYes && data?.step_2_yes_call_logs && <DynamicTable data={data?.step_2_yes_call_logs} /> }
    {onClickNo && data?.step_2_no_call_logs && <DynamicTable data={data?.step_2_no_call_logs} /> }
    
  </div>
  )
}

SectionTwo.propTypes = {

}

export default SectionTwo

